import { SeatLegroomReducedIcon } from './SeatLegroomReducedIcon';

/**
 * author: Google
 * id 4306743D-7833-44E7-88AB-659DD694C8B0
 * name seat-legroom-reduced
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-legroom-reduced.svg
 * tags
 */
export const AirlineSeatLegroomReducedIcon = SeatLegroomReducedIcon;
export default AirlineSeatLegroomReducedIcon